let host = window.location.protocol + "//" + window.location.host;
export default {
  /**
   * @description 配置显示在浏览器标签的title
   */
  title: '',
  /**
   * @description api请求基础路径
   */
  /* 各种url */
  baseUrl: {
    dev: "http://vote.cq.qiludev.com",
    // pro: 'http://api.votesignup.test.qiludev.com',
    pro: host
  },
  goBackUrl: {
    dev: "http://chuangqi.test.qiludev.com/cq-admin/index.html",
    pro: "http://appadmin.iqilu.com/cq-admin/index.html",
  },
}

export const secret = "c058579161250b3748dce77cf43eb6c3"
export const baseUrl = {
  dev: "http://api.votesignup.test.qiludev.com",
  uat: "http://app-vs.uat.qiludev.com",
  pro: host
}
export const DEVTOKEN = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJnaWQiOjAsInQiOjE2NDYyMTI4MTMsIm9wZW5pZCI6IjNzRGpmMkxxWWdJSzd2bE0tR0Z3YXciLCJpc3MiOiJjcSIsIm5pY2tuYW1lIjoi5omY5rSb5aSrIiwiYXZhdGFyIjoiaHR0cHM6Ly9pbWcxMS5pcWlsdS5jb20vYXZhdGFyL2M3LzRkLzE2LnBuZz8xNjQwNjcyODg5MzEyIiwidGltZSI6MTY0NjIxMjgxMywib3JnaWQiOjI5LCJwbGF0Zm9ybSI6ImNodWFuZ3FpIn0.0UU00R2uCBGwD-_-qtLENVFqcZJdxjVti3_FITlmJ54'

const appDownloadURL = 'https://app.iqilu.com/download/jump?orgid='